//-- React Standard
import { Badge, Button, Card, CardBody, CardFooter, CardHeader, Col, Collapse, Fade, Row, FormGroup, Label, Input } from 'reactstrap';
import React, { Component } from "react";
import { connect } from 'react-redux';
//import compose from 'recompose/compose';
import config from '../../config';
//-- Custom
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import { withStyles } from "@material-ui/core/styles";
import Footer from "../Common/Footer/Footer";

//-- CSS for Material
const styles = theme => ({
    error: {
        color: 'red',
    }
});

class Settings extends Component {
    constructor(props) {
        super(props);
        this.toggleAccordion = this.toggleAccordion.bind(this);


        this.state = {
            accordion: [false, false, false],
        };
    }

    toggleAccordion(tab) {

        const prevState = this.state.accordion;
        const state = prevState.map((x, index) => tab === index ? !x : false);

        this.setState({
            accordion: state,
        });
    }

    //-- Main function
    render() {
        const { classes, match, history } = this.props;
        const { id, shopname } = match.params;

        const { siteConstants } = this.props.language;
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.MENU_SETTINGS}
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12">
                                    <Card>
                                        <CardHeader>
                                            <strong>{siteConstants.MENU_SETTINGS}</strong>
                                        </CardHeader>
                                        <CardBody>
                                            <Card className="mb-2">
                                                <CardBody>
                                                    <Row className="mb-4">
                                                        <Col xs="1" style={{ textAlign: "right" }}>
                                                            <i className="fa fa-laptop"></i>
                                                        </Col>
                                                        <Col xs="3">
                                                            <FormGroup>
                                                                <a href="/general-settings" className="fontBold">{siteConstants.MENU_GENERAL_SETTINGS}</a>
                                                                <div>{siteConstants.GENERAL_SETTINGS_DESC}</div>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col xs="1" style={{ textAlign: "right" }}>
                                                            <i className="fa fa-laptop"></i>
                                                        </Col>
                                                        <Col xs="3">
                                                            <FormGroup>
                                                                <a href="/tax-setting" className="fontBold">{siteConstants.MENU_TAX_SETTING}</a>
                                                                <div>{siteConstants.MENU_SETTINGS_DESCRIPTION}</div>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col xs="1" style={{ textAlign: "right" }}>
                                                            <i className="fa fa-laptop"></i>
                                                        </Col>
                                                        <Col xs="3">
                                                            <FormGroup>
                                                                <a href="/payment-types" className="fontBold">{siteConstants.MENU_PAYMENT_TYPE}</a>
                                                                <div>{siteConstants.MENU_SETTINGS_DESCRIPTION}</div>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col xs="1" style={{ textAlign: "right" }}>
                                                            <i className="fa fa-laptop"></i>
                                                        </Col>
                                                        <Col xs="3">
                                                            <FormGroup>
                                                                <a href="/predefined-messages" className="fontBold">{siteConstants.MENU_PRE_MESSAGES}</a>
                                                                <div>{siteConstants.NOTIFICATIONS_DESC}</div>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col xs="1" style={{ textAlign: "right" }}>
                                                            <i className="fa fa-laptop"></i>
                                                        </Col>
                                                        <Col xs="3">
                                                            <FormGroup>
                                                                <a href="/legal" className="fontBold">{siteConstants.GEN_LEGAL}</a>
                                                                <div>{siteConstants.MENU_SETTINGS_DESCRIPTION}</div>
                                                            </FormGroup>
                                                        </Col>
                                                        <Col xs="1" style={{ textAlign: "right" }}>
                                                            <i className="fa fa-laptop"></i>
                                                        </Col>
                                                        <Col xs="3">
                                                            <FormGroup>
                                                                <a href="/banners" className="fontBold">{siteConstants.GEN_BANNERS}</a>
                                                                <div>{siteConstants.MENU_SETTINGS_DESCRIPTION}</div>
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>



                                        </CardBody>
                                    </Card>
                                </div>
                            </div>
                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}
                    <Footer />
                </div>
            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, getProduct, deleteProduct } = state;
    return {
        language,
        getProduct,
        deleteProduct
    };
}
const connectedSettings = connect(mapStateToProps)(withStyles(styles)(Settings));
export { connectedSettings as Settings };
